export const TEXT_ANIMATION_DURATION = 0.05
export const OPTIONS_ANIMATION_DURATION = 0.15